import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { borderColor, rgba } from "common/constants/Colors";
import { getTabColor, getFilterdMemos } from "common/store";
import { title, previewContent } from "common/assets/js/textSplitter";
import {
  archiveMemo,
  deleteMemo,
  renameCategory,
  removeCategory,
} from "common/actions";

class MemoList extends React.Component<{
  setting: any;
  selectedMemoId: any;
  categories: any;
  memos: any;
  onSelectMemo: (id: string) => void;
  archiveMemo: ({ id }: { id: string }) => void;
  deleteMemo: ({ id }: { id: string }) => void;
  onSelectMoveMemo: ({ id }: { id: string }) => void;
  renameCategory: ({
    id,
    categoryName,
  }: {
    id: string;
    categoryName: string;
  }) => void;
  removeCategory: ({ id }: { id: string }) => void;
}> {
  _archiveMemo = ({ e, id }) => {
    e.stopPropagation();
    const { memos } = this.props;
    if (memos[id].cat.length) {
      if (window.confirm("メモをゴミ箱にいれてもよろしいですか？")) {
        this.props.archiveMemo({ id });
        this.props.onSelectMemo(null);
      }
    } else {
      if (
        window.confirm(
          "メモを削除してもよろしいですか？（この操作は取り消せません）"
        )
      ) {
        this.props.deleteMemo({ id });
        this.props.onSelectMemo(null);
      }
    }
  };

  _openMoveMemoModal = ({ e, id }) => {
    e.stopPropagation();
    this.props.onSelectMoveMemo(id);
  };

  _renameCat = () => {
    const { categories } = this.props;
    const inputCatName = prompt(
      "カテゴリ名を入力してください（15文字以内)",
      categories.list[categories.nowTabCategory].name
    );
    if (inputCatName) {
      this.props.renameCategory({
        id: categories.nowTabCategory,
        categoryName: inputCatName,
      });
    }
  };

  _deleteCat = () => {
    const { categories } = this.props;
    if (categories.order.length < 2) {
      alert("タブが一つしかないため削除できません");
      return;
    }
    if (getFilterdMemos(categories.nowTabCategory).length) {
      alert("メモが存在するため、移動・削除してから実行してください。");
      return;
    }
    if (
      window.confirm(
        categories.list[categories.nowTabCategory].name +
          "タブを削除してもよろしいですか？"
      )
    ) {
      this.props.removeCategory({
        id: categories.nowTabCategory,
      });
    }
  };

  render() {
    const { isHiddenPreview } = this.props.setting;

    const { categories, selectedMemoId } = this.props;
    const activeColor = getTabColor(categories.nowTabCategory);
    const isTrach = !categories.nowTabCategory;
    const catName = isTrach
      ? "ゴミ箱"
      : categories.list[categories.nowTabCategory].name;

    return (
      <Wrapper activeColor={activeColor}>
        <div className="catTitle">
          <p>{catName}</p>
          {!isTrach && (
            <React.Fragment>
              <button className="editCatName" onClick={this._renameCat}>
                <i className="fas fa-pen" />
              </button>
              <button className="editCatName" onClick={this._deleteCat}>
                <i className="fas fa-trash-alt" />
              </button>
            </React.Fragment>
          )}
        </div>
        {getFilterdMemos(categories.nowTabCategory).map((content, index) => {
          const isActive = Boolean(content.id === selectedMemoId);
          return (
            <div
              className="memo"
              key={index}
              data-active={isActive}
              onClick={() => this.props.onSelectMemo(content.id)}
            >
              <p className="memoTitle" data-haspreview={!isHiddenPreview}>
                {title(content.text)}
              </p>
              {!isHiddenPreview && (
                <p className="memoPreview">{previewContent(content.text)[0]}</p>
              )}
              {!isHiddenPreview && (
                <p className="memoPreview">{previewContent(content.text)[1]}</p>
              )}
              {isActive && (
                <React.Fragment>
                  <button
                    className="moveMemo"
                    onClick={e =>
                      this._openMoveMemoModal({ e, id: content.id })
                    }
                  >
                    <i className="fas fa-reply" />
                  </button>
                  <button
                    className="deleteMemo"
                    onClick={e => this._archiveMemo({ e, id: content.id })}
                  >
                    <i className="fas fa-trash-alt" />
                  </button>
                </React.Fragment>
              )}
            </div>
          );
        })}
      </Wrapper>
    );
  }
}

export default connect(
  ({ categories, memos, setting }) => ({ categories, memos, setting }),
  {
    renameCategory,
    removeCategory,
    archiveMemo,
    deleteMemo,
  }
)(MemoList);

const Wrapper = styled.div<{ activeColor: string }>`
  /*２列の場合*/
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  width: 250px;
  &::-webkit-scrollbar {
    display: none;
  }

  padding-bottom: 54px;
  border-right: 1px solid ${borderColor};
  .catTitle {
    position: relative;
    padding: 16px;
    border-bottom: 1px solid ${borderColor};
    p {
      font-size: 18px;
      display: inline;
      margin-right: 8px;
      font-weight: bold;
    }
    button {
      color: #999;
      margin-right: 8px;
    }
  }
  .memo {
    position: relative;
    width: 100%;
    margin-right: 10px;
    text-align: left;
    padding: 8px;
    box-sizing: border-box;
    border-bottom: 1px solid ${borderColor};
    text-overflow: "";
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      opacity: 0.75;
    }
    &[data-active="true"] {
      background-color: ${props => rgba(props.activeColor, 0.2)};
    }
    button {
      position: absolute;
      top: 4px;
      color: #999;
      border-radius: 4px;
      padding: 6px 8px;
      background-color: rgba(255, 255, 255, 0.5);
      &:hover {
        background-color: ${props => rgba(props.activeColor, 0.8)};
      }
    }
    .deleteMemo {
      right: 5px;
    }
    .moveMemo {
      right: 37px;
    }
    .memoTitle {
      overflow: hidden;
      &[data-haspreview="true"] {
        font-weight: bold;
      }
    }
    .memoPreview {
      margin-top: 4px;
      overflow: hidden;
    }
  }
`;
